import { render, staticRenderFns } from "./BannerCtaComp.vue?vue&type=template&id=30646474&scoped=true&"
import script from "./BannerCtaComp.vue?vue&type=script&lang=js&"
export * from "./BannerCtaComp.vue?vue&type=script&lang=js&"
import style0 from "./BannerCtaComp.vue?vue&type=style&index=0&id=30646474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30646474",
  null
  
)

export default component.exports